/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ChangeRequestReviewRequest({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M2.299 3.56A6.368 6.368 0 0 1 5.104 1.72a6.385 6.385 0 0 1 5.902 1.02 6.427 6.427 0 0 1 1.274 1.313 6.455 6.455 0 0 1 .893 1.748h1.253a7.552 7.552 0 0 0-.832-1.938l-.007-.01-.004-.008a7.562 7.562 0 0 0-2.728-2.646A7.56 7.56 0 0 0 7.467.209a7.584 7.584 0 0 0-2.735.37 7.568 7.568 0 0 0-3.299 2.149l-.24-1.28A.61.61 0 0 0 .49.963a.59.59 0 0 0-.48.692l.53 2.82a.61.61 0 0 0 .701.487l2.851-.494a.59.59 0 0 0 .48-.692.61.61 0 0 0-.701-.487l-1.573.272ZM12.127 12.44a6.367 6.367 0 0 1-2.806 1.841 6.386 6.386 0 0 1-5.902-1.02 6.427 6.427 0 0 1-1.273-1.313 6.462 6.462 0 0 1-.893-1.748H0l.02.073a7.55 7.55 0 0 0 .813 1.865l.006.01a7.562 7.562 0 0 0 2.732 2.654 7.56 7.56 0 0 0 3.388.989 7.583 7.583 0 0 0 2.735-.37 7.567 7.567 0 0 0 3.299-2.149l.24 1.279a.61.61 0 0 0 .702.487.59.59 0 0 0 .48-.692l-.53-2.82a.61.61 0 0 0-.702-.487l-2.85.494a.59.59 0 0 0-.48.692.61.61 0 0 0 .701.487l1.573-.272Z" clipRule="evenodd" /></svg>;
}
;